import { Model as e } from "../../../../model.js";
class i extends e {
  constructor(s) {
    super(), this.language = s.language, this.address = s.address, this.access = s.access, this.user = s.user, this.cashback = s.cashback, this.analytics = s.analytics, this.shop = s.shop;
  }
}
export {
  i as ShopSessionSettingsModel
};
//# sourceMappingURL=settings.model.js.map
